import { jsx as r } from "react/jsx-runtime";
import { c as h } from "../../index-Cu0xwYjD.js";
import { TextVariant as p } from "../../utils/enums.js";
import { SkeletonMode as v } from "./Skeleton.types.js";
import { toCSSLengthValue as i } from "../../utils/helpers.js";
import { IressText as f } from "../Text/Text.js";
const S = "ids-skeleton-v501", g = "ids-skeleton--rect-v501", u = "ids-skeleton--circle-v501", T = "ids-skeleton--text-v501", c = {
  skeleton: S,
  "iress-skeleton-loading": "ids-skeleton--iress-skeleton-loading-v501",
  rect: g,
  circle: u,
  text: T
}, a = ({
  className: l,
  height: s,
  width: o,
  textVariant: d,
  mode: n = "text",
  style: e,
  ...m
}) => {
  const t = n === "text", k = {
    ...e,
    width: o ? i(o) : e == null ? void 0 : e.width,
    height: !t && s ? i(s) : e == null ? void 0 : e.height
  }, x = h(l, c.skeleton, c[n], {
    "iress-u-text": t
  });
  return /* @__PURE__ */ r(
    "div",
    {
      ...m,
      className: x,
      style: k,
      "aria-hidden": "true",
      children: t && /* @__PURE__ */ r(f, { variant: d, children: " " })
    }
  );
};
a.Mode = v;
a.TextVariant = p;
export {
  a as IressSkeleton
};
